import slEventBus from '../../utils/slEventBus';
import eventBus from './eventBus';

function _setupEvent(schema) {
  const externalEventName = schema.sdkEvent ?? schema.incomingEvent;
  const sticky = !!schema.sticky;
  slEventBus.on(
    schema.incomingEvent,
    (payload) => {
      const transformedPayload =
        typeof schema.transform === 'function'
          ? schema.transform(payload)
          : payload;
      eventBus.emit(externalEventName, transformedPayload, { sticky });
    },
    { debug: process.env.NODE_ENV === 'development', sticky },
  );
}

function _setupEvents(eventsSchema) {
  if (!eventsSchema) return;

  for (const eventSchema of eventsSchema) {
    _setupEvent(eventSchema);
  }
}

export { _setupEvents };
